import React, { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Menu from "../../helpers/Menu";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { Sidebar } from "primereact/sidebar";

import "./index.css";

import { CheckboxField } from "../../helpers";
import { Table } from "../../helpers"

import Loading from "../../common/Loading"
import PMCompanyName from "../../common/PMCompanyName";
import PMUserName from "../../common/PMUserName";
import Description from "../../common/Description";
import ButtonGroup from "../../common/ButtonGroup";
import CopyToClipboard from "../../common/CopyToClipboard";

import { updateAdjustmentNoteBookingStatus } from "../../services/api/adjustmentNotes";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchAdjustmentReasons } from "../../services/redux/reducers/commonThunk";
import { fetchBuyerCreditNotes, updateSearchParams, setIsSearchVisible } from "../../services/redux/reducers/buyerCreditNote/buyerCreditNote";
import { getDateString, getCompanyShortName, numberConversion, isMobile } from "../../utils";

import BuyerCNDNandInvoiceSplitView from "./Components/BuyerCNDNAndInvoiceSplitView";
import Search from "./Components/Search";

import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const BuyerDebitNoteBooking = () => {
    const [selectedAdjustmentNotes, setSelectedAdjustmentNotes] = useState([])
    const [isPageLoading, setIsPageLoading] = useState(false)
    const [visibleBuyerCNDNAndInvoiceSplitView, setVisibleBuyerCNDNAndInvoiceSplitView] = useState(false)
    const [selectedViewBuyerCNDNandInvoice, setSelectedViewBuyerCNDNandInvoice] = useState({})

    const usersData = useSelector(state => state.userDetails)
    const isLoading = useSelector(state => state.buyerCreditNotes.loading)
    const searchParams = useSelector(state => state.buyerCreditNotes.searchParams)
    const paginationParams = useSelector(state => state.buyerCreditNotes.paginationParams)
    const adjustmentNotesData = useSelector(state => state.buyerCreditNotes.buyerCNDNData)
    const isSearchVisible = useSelector(state => state.buyerCreditNotes.isSearchVisible)
    const isSearchActive = useSelector(state => state.buyerCreditNotes.isSearchActive)

    const adjustmentReasons = useSelector(state => state.common.adjustmentReasons)

    const pmCompanyConfig = getPMCompanyConfig(usersData.PMCompanyDetails.companyId)
    const numberLocale = pmCompanyConfig.numberLocale

    const actionMenu = useRef(null)
    const dispatch = useDispatch()

    const isMobileDevice = isMobile()

    useEffect(()=>{
        let updatedSearchParams = { ...searchParams, adjustmentTypeIds: [1] }
        dispatch(updateSearchParams(updatedSearchParams))

        dispatch(fetchAdjustmentReasons())
    },[])

    useEffect(() => {
        handleTableColumn(searchParams)
    }, [adjustmentNotesData, selectedAdjustmentNotes])

    const getIntialLoadData = () => {
        if(isPageLoading){
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 30)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
        }
    }

    const getKAMBody = (row)=>{
        let kamName = row["users.firstName"] 

        if(row["users.lastName"]){
            kamName = kamName + " " + row["users.lastName"]
        }
        return <PMUserName userName={kamName} userId={row.createdBy}/>
    }

    const getCompanyBody = (row)=>{
        let companyShortName = getCompanyShortName(row["company.companyName"])
        
        return <PMCompanyName companyName={companyShortName} companyId={row.companyId}/>
    }

    const getBookedStatusBody = (row)=>{
        return(
            <div className="">
                <div>{row["docTracker.bookedStatus"] ? "Yes" : "No" }</div>
            </div> 
        )
    }

    const getHeaderCheckbox = ()=>{
        
        return(
            <div className="text-center"> <CheckboxField onChange={(e) => handleSelectClick(e)}  checked={adjustmentNotesData?.length && adjustmentNotesData?.length === selectedAdjustmentNotes?.length}/></div>
        )
    }

    const getBodyCheckbox = (row)=>{
        
        const relatedAdjustmentNote = selectedAdjustmentNotes?.find(eachAdjustmentNote => eachAdjustmentNote?.adjustmentNoteId === row?.adjustmentNoteId)
        
        return(
            <div className="">
                <CheckboxField onChange={() => handleCheckboxClick(row)} checked={relatedAdjustmentNote ? true : false}/>
            </div>
        )
    }

    const getBuyerDebitNoteDocBody = (row) => {
        
        let dateString = getDateString(row?.createdAt)
        let naviationLink = row?.adjustmentTypeId === 1 ? `/credit_note/${row?.adjustmentNoteId}` : `/buyer-debit-note/${row?.adjustmentNoteId}`
        
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center' >
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(naviationLink, '_blank')}>{row?.docNo ? row?.docNo : "NA"}</p>
                    <CopyToClipboard text={row?.docNo} />
                </div>
                <div className="date-string">{dateString}</div>
            </div>
        )
    }

    const getBuyerInvoiceBody = (row) => {
        
        let dateString = getDateString(row["buyerInvoice.createdAt"])
       
        return (
            <div className="text-center">
                <div className='flex flex-row justify-content-center' >
                    <p className='doc-no' style={{cursor : "pointer"}} onClick={() => window.open(`/buyerInvoice/${row["buyerInvoice.buyerInvoiceId"]}`, '_blank')}>{row["buyerInvoice.docNo"]}</p>
                    <CopyToClipboard text={row["buyerInvoice.docNo"]} />
                </div>
                <div className="date-string">{dateString}</div>
            </div>
        )
    }

    const getViewBody = (row)=>{
        return(
            <div className="">
                <div className="flex justify-content-center align-items-center">
                    <i className="pi pi-eye text-base cursor-pointer ml-1 compare-tooltip text-teal-500" onClick={() => {setVisibleBuyerCNDNAndInvoiceSplitView(true); setSelectedViewBuyerCNDNandInvoice(row)}} />
                </div>
                <Tooltip target={`.compare-tooltip`} showDelay={1000} hideDelay={300} position="top">
                    <p>Click here to view both buyer {searchParams?.dataType === "creditNote" ? "Credit Note" : "Debit Note"} and Invoice</p>
                </Tooltip>
            </div> 
        )
    }

    const getTotalAmountBody = (row) => {
        return (
            <>
                <p>{numberConversion(parseFloat(row["buyerInvoice.totalInvAmount"]), numberLocale)}</p>
            </>
        )
    }

    const getRemarksBody = (row) => {
        let updatedRemarks = ""

        if (adjustmentReasons.length){
            let relatedAdjustmentNoteReason = adjustmentReasons.find(eachAdjustmentReason => eachAdjustmentReason.adjustmentReasonId === row.adjustmentReasonId)

            let adjustmentNoteReasonRemarks = relatedAdjustmentNoteReason ? `Reason: ${relatedAdjustmentNoteReason.adjustmentReasonName} ` : ""
            if (row.returnToSeller){
                adjustmentNoteReasonRemarks += `(Return To Seller)`
            }

            updatedRemarks = `${adjustmentNoteReasonRemarks} \n` + updatedRemarks 
        }
        return (
            <>
                {updatedRemarks ? <div className="text-left" style={{fontWeight: '600', fontSize: '14px'}}>{updatedRemarks}</div> : ""}
                {row.remarks ?  <Description text={row.remarks} maxLength={100} /> : ""}
            </>
        )
    }

    const handleCopyClick = (docNo) => {
        if(docNo){
            navigator.clipboard.writeText(docNo)
            .then(() => {
                return dispatch(raiseToast({severity:'success', detail: "Copied!", life: 3000}))
            })
            .catch((error) => {
                return dispatch(raiseToast({severity:'error', detail: "Can't copy", life: 3000}))
            })
        }
    }

    const handleSearchTabDisplay = () => {
        dispatch(setIsSearchVisible(!isSearchVisible))
    }
    
    const getBuyerDebitNoteRemarksBody = (row) =>{
        return(
            row.remarks ? <Description text={row.remarks} maxLength={100} /> : <p className="text-center">-</p>
        )
    }

    const creditNoteTableColumns = [
        {
            header: getHeaderCheckbox, 
            field: 'header',
            body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Company Name',
            field: '',
            body : getCompanyBody,
            style: {minWidth: '200px'}
        },
        {
            header: 'Credit Note No',
            field: 'docNo',
            body: getBuyerDebitNoteDocBody,
            style: {minWidth: '120px'}
        },
        {
            header: 'Invoice No',
            field: '',
            body: getBuyerInvoiceBody,
            style: {minWidth: '130px'}

        },
        {
            header : 'KAM',
            field : '',
            body : getKAMBody,
            style: {minWidth: '120px'}
        },
        {
            header: 'Total Amount',
            field: '',
            body: getTotalAmountBody,
            style: {minWidth: '100px'}
        },
        {
            header: 'Booking Status',
            field: '',
            body : getBookedStatusBody,
            style: {minWidth: '100px'}
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarksBody,
            style: {minWidth: '300px'}
        },
        {
            header: 'View',
            field: '',
            body : getViewBody,
            style: {minWidth: '70px'}
        }
    ]

    const debitNoteTableColumns = [
        {
            header: getHeaderCheckbox,
            field: 'header',
            body: (row) => getBodyCheckbox(row)
        },
        {
            header: 'Company Name',
            field: '',
            body : getCompanyBody,
            style: {minWidth: '200px'}
        },
        {
            header: 'Debit Note No',
            field: 'docNo',
            body: getBuyerDebitNoteDocBody,
            style: {minWidth: '130px'}
        },
        {
            header: 'Invoice No',
            field: '',
            body: getBuyerInvoiceBody,
            style: {minWidth: '130px'}
        },
        {
            header : 'KAM',
            field : '',
            body : getKAMBody,
            style: {minWidth: '110px'}

        },
        {
            header: 'Total Amount',
            field: '',
            body: getTotalAmountBody,
            style: {minWidth: '90px'}
        },
        {
            header: 'Booking Status',
            field: '',
            body : getBookedStatusBody,
            style: {minWidth: '150px'}
        },
        {
            header: 'Remarks',
            field: 'remarks',
            body: getRemarksBody,
            style: {minWidth: '400px'}
        },
        {
            header: 'View',
            field: '',
            body : getViewBody
        }
    ]

    let [ tableColumns, setTableColumns ] = useState(creditNoteTableColumns)

    const handleTableColumn = (searchParams) => {
        const { dataType } = searchParams

        switch(dataType) {
            case "creditNote" :
                setTableColumns(creditNoteTableColumns)
                break
            case "debitNote" :
                setTableColumns(debitNoteTableColumns)
                break
        }
    }

    const actionMenuItems = [
        {
            label: 'Book Adjustment Note',
            icon: '',
            command : () => handleBookAdjustmentNoteClick(),
            permissions: [107]
        },
        {
            label: 'UnBook Adjustment Note',
            icon: '',
            command : () => handleUnBookAdjustmentNoteClick(),
            permissions: [107]
        },
    ];


    const handlePageChange = async (e) => {
        let adjustmentNotesParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }

        if (adjustmentNotesParams.searchBy !== "all") {
            adjustmentNotesParams[adjustmentNotesParams.searchBy] = adjustmentNotesParams.searchText.trim()
        }
        //dispatch(fetchBuyerCreditNotes({...adjustmentNotesParams, adjustmentTypeIds : [1, 2] }))
        dispatch(fetchBuyerCreditNotes({...adjustmentNotesParams }))
    }

    const handleCheckboxClick = (row) => {
        const relatedAdjustmentNote = selectedAdjustmentNotes?.find(eachAdjustmentNote => eachAdjustmentNote.adjustmentNoteId === row?.adjustmentNoteId)
        if (relatedAdjustmentNote){
            const relatedAdjustmentNotes = selectedAdjustmentNotes?.filter(eachAdjustmentNote => eachAdjustmentNote?.adjustmentNoteId !== relatedAdjustmentNote?.adjustmentNoteId)
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }else {
            const relatedAdjustmentNotes = [...selectedAdjustmentNotes, row]
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }
    }

    const handleSelectClick = (e) => {
        const relatedAdjustmentNotes = adjustmentNotesData?.map(eachAdjustmentNote => eachAdjustmentNote)
        if (e.checked){
            setSelectedAdjustmentNotes(relatedAdjustmentNotes)
        }else{
            setSelectedAdjustmentNotes([])
        }
    }

    const handleBookAdjustmentNoteClick = async () => {
        if (selectedAdjustmentNotes?.length > 0){
            const relatedDocNos = selectedAdjustmentNotes?.map(eachAdjustmentNote => parseInt(eachAdjustmentNote?.docNo))
            const bookingLogs = selectedAdjustmentNotes?.map(eachAdjustmentNote => {
                return {
                    docNo : eachAdjustmentNote?.docNo,
                    bookedBy : usersData?.userId,
                    bookedAt : new Date()
                }
            })
            const data = {
                docNos : relatedDocNos,
                bookingStatus : true,
                updatedBy : usersData?.userId,
                bookingLogs : bookingLogs
            }
            setIsPageLoading(true)
            const response = await updateAdjustmentNoteBookingStatus(data)
            console.log("res", response)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {
                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedAdjustmentNotes([])
                //dispatch(fetchBuyerCreditNotes({...paginationParams, ...searchParams, adjustmentTypeIds: [1, 2]}))
                dispatch(fetchBuyerCreditNotes({...paginationParams, ...searchParams}))
            }
            setIsPageLoading(false)
        }else {
            dispatch(raiseToast({severity:'warn', detail: 'Select Debit Notes', life: 3000}))
        }
    }

    const handleUnBookAdjustmentNoteClick = async () => {
        if (selectedAdjustmentNotes?.length > 0){
            const relatedDocNos = selectedAdjustmentNotes?.map(eachAdjustmentNote => eachAdjustmentNote?.docNo)
            const bookingLogs = selectedAdjustmentNotes?.map(eachAdjustmentNote => {
                return {
                    docNo : eachAdjustmentNote?.docNo,
                    unbookedBy : usersData?.userId,
                    unbookedAt : new Date()
                }
            })
            const data = {
                docNos : relatedDocNos,
                bookingStatus : false,
                updatedBy : usersData?.userId,
                bookingLogs : bookingLogs
            }
            setIsPageLoading(true)
            const response = await updateAdjustmentNoteBookingStatus(data)
            if (response?.failure){
                dispatch(raiseToast({severity:'error', summary: 'Booking Status is not Updated', detail:response.data.error, life: 3000}))
            }else {
                dispatch(raiseToast({severity:'success', detail: 'Booking Status Updated Successfully', life: 3000}))
                setSelectedAdjustmentNotes([])
                //dispatch(fetchBuyerCreditNotes({...paginationParams, ...searchParams, adjustmentTypeIds : [1, 2]}))
                dispatch(fetchBuyerCreditNotes({...paginationParams, ...searchParams}))
            }
            setIsPageLoading(false)
        }else {
            dispatch(raiseToast({severity:'warn', detail: 'Select Debit Notes', life: 3000}))
        }
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleSearchTabDisplay(),
            className: isSearchActive ? "active-group-button" : ""
        },
    ]
    
    return(
        <div className="piwise-invoce-booking-layout flex flex-column">
            <div className="flex flex-column md:flex-row md:justify-content-between">
                {/*<h4 className="m-2">BUYER CREDIT NOTE</h4> */}
                <h4 className="mx-2 my-1 md:m-2">{searchParams?.dataType === "creditNote" ? "BUYER CREDIT NOTE" : "BUYER DEBIT NOTE"}</h4>
                <div className="flex flex-row justify-content-end md:justify-content-between mb-2">
                    {/* <div className="mr-2 justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                    <div className="flex justify-content-end mb-2">
                        <Button icon="pi pi-filter" className={`h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300 ${isSearchActive ? 'search-filter-active' : ''}`} label="Filter" onClick={handleSearchTabDisplay} />
                    </div> */}
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <ButtonGroup buttons={actionButtons} />
                </div>
            </div>
            <Loading visible={isPageLoading}/>
            <div className='flex flex-row'>
                <div className="" style={{ order: "1", width: isSearchVisible && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'"}}>
                    <div className='p-card mb-0'>
                        <div className="flex-grow-1 petty-cash-table" >
                            <Table
                                lazy 
                                scrollable={"true"} 
                                scrollHeight={"550px"} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                paginator 
                                page={paginationParams.pageNo}
                                totalRecords={paginationParams.totalRecords}
                                tableColumns={tableColumns}
                                rows={paginationParams.recordsPerPage}
                                excessPagesFound= {paginationParams.excessPagesFound}
                                data={adjustmentNotesData}
                                loading={isLoading}
                            />
                        </div>
                    </div>
                </div>

                {
                    isSearchVisible && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Search handleTableColumn={handleTableColumn} adjustmentReasons={adjustmentReasons} />
                    </div>
                }

                {
                    isSearchVisible && isMobileDevice && 
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isSearchVisible} onHide={() => dispatch(setIsSearchVisible(false))}>
                            <Search handleTableColumn={handleTableColumn} adjustmentReasons={adjustmentReasons} />                        
                        </Sidebar>
                    </div>
                }
            </div>
            <Dialog className="buyer-cn-and-invoice-split-view-dialog" header={searchParams?.dataType === "creditNote" ? "BUYER CREDIT NOTE and INVOICE" : "BUYER DEBIT NOTE and INVOICE"} visible={visibleBuyerCNDNAndInvoiceSplitView} style={{ width: '90vw', height: '85vh'}} onHide={() => setVisibleBuyerCNDNAndInvoiceSplitView(false)}>
                <BuyerCNDNandInvoiceSplitView buyerCNDNURL={selectedViewBuyerCNDNandInvoice['docCopyURL.docLocation']} buyerInvoiceURL={selectedViewBuyerCNDNandInvoice['buyerInvoice.docCopyURL.docLocation']}  />
            </Dialog>
        </div>
    )
}

export default BuyerDebitNoteBooking;